import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as CheckIcon } from './assets/asc-check.svg';

interface Props {
  dark?: boolean;
  startIcon?: React.ReactNode;
  children?: React.ReactNode;
  sx?: object;
}

const ASCSmallCheck: React.FC<Props> = ({ dark = false, children, startIcon, sx }) => {
  const theme = useTheme();
  const color = dark ? theme.palette.darkBlue.main : theme.palette.common.white;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={0.5}
      borderRadius={2}
      padding={0}
      bgcolor="transparent"
      {...sx}
    >
      {startIcon ?? <CheckIcon style={{ color }} />}
      <Typography
        component="span"
        fontSize={14}
        fontWeight={700}
        fontStyle="normal"
        color={color}
      >
        {children ?? <FormattedMessage id="orderFeed.asc" />}
      </Typography>
    </Box>
  );
};

export default React.memo(ASCSmallCheck);